import axios from "axios";
import { DailyReport, DailyReportDetails } from "../types/dailyReportTypes";
import apiClient from "./apiClient";

// --- INTERFAZ PARA RESPUESTA HÍBRIDA ---
export interface DailyReportSaveResponse {
    dailyReport: DailyReport;
    warnings: string[];
}

export const getDailyReports = async (): Promise<DailyReport[]> => {
    try {
        const response = await apiClient.get(`/Daily-reports`);
        return response.data;
    } catch (error) {
        console.error('Error al obtener los reportes diarios:', error);
        throw error;
    }
};

export const getDailyReportById = async (id: number): Promise<DailyReport> => {
    try {
        const response = await apiClient.get(`/Daily-reports/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error al obtener el reporte diario con id: ${id}:`, error);
        throw error;
    }
};

// --- CREATE CORREGIDO: Recibe el payload listo ---
export const createDailyReport = async (payload: any): Promise<DailyReportSaveResponse> => {
    try {
        // Ya no procesamos nada aquí, el componente CreateDailyReport.tsx
        // ya nos envía el objeto { dailyReport, activities, productionRows... } listo.
        const response = await apiClient.post<DailyReportSaveResponse>(`/Daily-reports`, payload);
        return response.data;
    } catch (error) {
        console.error('Error al crear reporte diario:', error);
        throw error;
    }
};

// --- UPDATE CORREGIDO: Recibe ID y Payload listo ---
export const updateDailyReport = async (id: number, payload: any): Promise<DailyReportSaveResponse> => {
    try {
        // Enviamos el payload directamente
        const response = await apiClient.put<DailyReportSaveResponse>(`/Daily-reports/${id}`, payload);
        return response.data;
    } catch (error) {
        console.error(`Error al actualizar el Reporte Diario con id ${id}:`, error);
        throw error;
    }
};

export const deleteDailyReport = async (id: number): Promise<void> => {
    try {
        await apiClient.delete(`/Daily-reports/${id}`);
    } catch (error) {
        console.error(`Error al elimnar el reporte diario con id: ${id}`, error);
        throw error;
    }
};

export const getDailyReportByProjectId = async (projectId: number): Promise<DailyReport[]> => {
    try{
        const response = await apiClient.get(`/Daily-reports/by-project`, {
            params: { projectId }
        });
        return response.data;
    }catch(error){
        console.error(`Error al obtener reportes diarios del proyecto: ${projectId}:`, error);
        throw error;
    }
};

export const getLastDailyReport = async (projectId: number) => {
    try {
      const response = await apiClient.get(`/Daily-reports/lastDailyReport/${projectId}`);
      return response.data;
    } catch (error) {
      console.error("Error al obtener el último reporte:", error);
      return null;
    }
  };

export const getReportsByProjectIdAndController = async (projectId: number, identificationNum: string): Promise<DailyReport[]> => {
    try {
        const response = await apiClient.get(`/Daily-reports/by-project-and-idnum`, {
            params: { projectId, identificationNum }
        });
        return response.data;
    } catch (error) {
        console.error(`Error al obtener reporte del proyecto ${projectId} y control de obras ${identificationNum}:`, error);
        throw error;
    }
};

export const getDailyReportDetails = async (reportId: number): Promise<DailyReportDetails> => {
    const response = await apiClient.get<DailyReportDetails>(`/Daily-reports/${reportId}/details`);
    return response.data;
};